export default "__VITE_ASSET__DRpL5bSx__"